<!-- 招商推介详情 -->
<template>
  <div class="deal-center d_flex flex_direction_col">

    <div class="d_flex justify_content_sb flex_direction_col">
      <div class="main_block_1">
        <div
          class="state-time-line c_1A1A1A"
          style="margin-left: 31px;"
        >

          <div class="text_ellipsis priceSty">
            <span class="white_s_nowrap fz14 letSpacing ">
              价格：
            </span>
            <span class="font_w_bold c_CF3342 fz22 letSpacing">
              <span v-if="itemDetail.priceUnit !== 'mianyi'">{{ itemDetail.price }}</span>{{ itemDetail.priceUnitDesc }} </span>
          </div>
        </div>
        <div class="solid_line" />
        <div
          class="state-time-line c_1A1A1A"
        >

          <div class="text_ellipsis priceSty d_flex">
            <div>
              <div class="fz14 letSpacing">数量/面积</div>
              <div class="item_col font_w_bold letSpacing">{{ itemDetail.quantity }}{{ quantityUnitKey[itemDetail.quantityUnit] }}</div>
            </div>
            <div>
              <div class="fz14 letSpacing">转出方式</div>
              <div class="item_col font_w_bold letSpacing">{{ transferModes.filter(n => n.key === itemDetail.transferMode)[0].value }}</div>
            </div>
            <div>
              <div class="fz14 letSpacing">转出期限</div>
              <div class="item_col font_w_bold letSpacing">{{ itemDetail.deadline }}{{ deadlineUnitKey[itemDetail.deadlineUnit] }}</div>
            </div>
          </div>
        </div>
        <div class="solid_line" />
        <div
          :class="isLogin ? 'priceSty d_flex concat_sty':'priceSty noLoginSty'"
        >
          <div class="d_flex">
            <div><i class="el-icon-postcard icon_sty" /></div>
            <el-tooltip class="item" effect="dark" :content="itemDetail.contact" placement="bottom">
              <div :class="isLogin ? 'fz14 font_w_bold concat_margin letSpacing concat_overflow_isLogin':'fz14 font_w_bold concat_margin letSpacing concat_overflow'">联系人：{{ itemDetail.contact }}</div>
            </el-tooltip>
          </div>
          <div :class="isLogin ?'d_flex':'concatPhone_margin02 d_flex'">
            <div><i :class="isLogin ? 'el-icon-phone-outline icon_sty concatPhone_margin' :'el-icon-phone-outline icon_sty'" /></div>
            <div class="fz14 font_w_bold  concat_margin letSpacing">{{ checkPhoneNumber(itemDetail.contactPhone) }}</div>
            <div v-if="!isLogin" class="fz14 look_sty" @click="onLookPhone">查看完整号码</div>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
  },
  props: {
    itemDetail: {
      type: Object,
      default: () => {}
    },
    reqInfoTime: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      diffTime: null, // 时间差值（用于计算倒计时）
      countDownTimer: null,
      pollIntervalTimer: null,
      pollInterval: 1000 * 30, // 轮询间隔
      agreementReadModal: false
    }
  },
  computed: {
    ...mapGetters([
      'isLogin',
      'cmsNoticeNode',
      'userinfo',
      'priceUnitKey',
      'stateAllKey',
      'quantityUnitKey',
      'transferModes',
      'deadlineUnitKey'
    ])
  },
  watch: {

  },
  async created() {
    this.isHiddenPhone()
  },
  mounted() {
  },
  methods: {
    ...mapActions({
    }),
    // 根据登录判断是否隐藏手机号尾数
    isHiddenPhone() {
      if (!this.isLogin) {
        this.itemDetail.contactPhone = this.maskPhoneNumber(this.itemDetail.contactPhone)
      }
    },
    onLookPhone() {
      if (!this.isLogin) {
        if (!this.isLogin) {
          this.$router.push({
            path: '/login',
            query: {
              returnUrl: this.$route.fullPath,
              projectNo: this.itemDetail.id
            }
          })
          return
        }
      }
    },
    checkPhoneNumber(phoneNumber) {
      const regEx = /^.{4,11}$/
      if (!regEx.test(phoneNumber)) {
        return '手机号格式错误'
      } else {
        return phoneNumber
      }
    },
    maskPhoneNumber(phoneNumber) {
      const regEx = /^.{4,11}$/
      if (!regEx.test(phoneNumber)) {
        return '手机号格式错误'
      }
      // 将倒数第四位到倒数第八位的字符替换为 *
      const start = phoneNumber.length - 8 // 倒数第八位的索引
      const end = phoneNumber.length - 3 // 倒数第四位的索引
      const maskedPart = phoneNumber.substring(start, end).replace(/\d/g, '*') // 替换数字为 *

      // 构建新的电话号码字符串
      const maskedPhoneNumber = phoneNumber.substring(0, start) + maskedPart + phoneNumber.substring(end)

      return maskedPhoneNumber
    },
    // 页面可见 change
    pageVisibilitychange() {
      window.addEventListener('visibilitychange', this.handlePage)
    }
  },
  destroyed() {
    window.removeEventListener('visibilitychange', this.handlePage)
  }
}
</script>

<style lang="scss" scoped>
.deal-center {
  overflow: hidden;
  position: relative;
  width: 440px;
  margin: 0 10px;
  border: 1px solid #e6e6e6;
  .pro-state {
    position: absolute;
    top: 0;
    right: 0;
    width: 100px;
    height: 100px;
    line-height: 170px;
    transform: translate(50px, -50px) rotateZ(45deg);
    text-align: center;
    color: #fff;
    font-size: 12px;
  }
}

.state-time-line {
  margin: 10px 0;
  .state-time-countdown {
    display: inline-block;
  }
}
.price_w {
  margin: 10px 0;
  & > span {
    &:first-child {
      margin: 0 18px 0 0;
    }
  }
}
.state_end_desc {
  margin: 0 0 12px 0;
  & > img {
    margin: 0 14px 0 0;
  }
}
.main_block_2 {
  height: 140px;
  .block-outer {
    display: flex;
    justify-content: center;
    height: 100%;
    .block-inner {
      display: flex;
      align-items: center;
      .apply-btn {
        border-radius: 0;
        color: #fff !important;
        &:hover,
        &:focus {
          background-color: rgba($color: #0983cc, $alpha: 0.9);
        }
        &.is-disabled {
          color: #fff !important;
          background-color: #999 !important;
        }
      }
      .state-remark {
        padding: 0 50px;
        text-align: center;
        line-height: 22px;
        color: #666;
      }
    }
  }
}
.main_block_1 {
  position: relative;
  min-height: 100px;
  padding: 10px;
  box-sizing: border-box;
  .cell_label {
    display: inline-block;
    min-width: 60px;
    white-space: nowrap;
    text-align: right;
  }
  .time-i {
    margin: 0 4px 0 0;
  }
  .time-num {
    margin: 0 5px;
  }
  .tradeMode-text {
    position: absolute;
    right: 10px;
    top: 10px;
    font-size: 12px;
    background-color: #0983cc;
    color: #fff;
    padding: 4px 10px;
  }
}
.main_block_3 {
  .cell_i {
    height: 32px;
    line-height: 32px;
    flex: 1;
    text-align: center;
    border-bottom: 1px solid #e6e6e6;
    &:last-child {
      border-left: 1px solid #e6e6e6;
    }
  }
}
.cell_row {
  margin: 10px 0;
  align-items: baseline;
}
.main_block_4 {
  padding: 0 20px;
  .cell_row {
    margin: 10px 0;
  }
}
.priceSty{
  margin: 25px 20px;
}
.noLoginSty{
  margin-left: 48px;
  margin-top: 38px;
}
.icon_sty{
  color: #0983cc;
  font-size: 24px;
}
.text_ellipsis > div {
  flex: 1; /* 让每个 div 均分父容器的宽度 */
  text-align: center; /* 文字居中 */
  padding: 10px; /* 可选：添加内边距增加空白 */
  margin: 0 5px; /* 可选：添加外边距以增加间距 */
}
.concat_sty{
  margin-left: 51px;
  margin-top: 58px;
}
.concat_margin{
  margin-top: 4px;
  margin-left: 6px;
}
.look_sty{
  margin-top: 3px;
  margin-left: 10px;
  color: #0983cc;
}
.look_sty:hover{
  text-decoration: underline;
  cursor: pointer;
}
.concatPhone_margin{
  margin-left: 14px;
}
.concatPhone_margin02{
  margin-top: 10px;
}
.item_margin{
  padding-top: 58px;
}
.item_col{
  margin-top: 20px;
}
.letSpacing{
  letter-spacing: 1px;
}
.concat_overflow{
  width: 300px; /* 容器宽度 */
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 超出部分显示省略号 */
  white-space: nowrap; /* 单行文本，不换行 */
}
.concat_overflow_isLogin{
  width: 140px; /* 容器宽度 */
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 超出部分显示省略号 */
  white-space: nowrap; /* 单行文本，不换行 */
}
</style>
